<p-drawer (onHide)="onCancel()" [(visible)]="visible2" position="right" [style]="{width: '40vw'}" [modal]="true" [dismissible]="true"
    [showHeader]="false">
    <ng-template pTemplate="header">
        Report Security
    </ng-template>
    <form [formGroup]="reportSecurityForm" (ngSubmit)="saveReportSecurity()">
        <input type="hidden" formControlName="reportId" />
        <input type="hidden" formControlName="reportFrom" />
        <div class="mb-3">
            <div class="sectLab2 mb-3">View access configuration</div>
            <div class="sectWB">
                <div class="grid">
                    <div class="field col-6">
                        <label>Role</label>
                        <p-multiselect [options]="roleList" optionLabel="name"  optionValue="code" formControlName="viewRoleIds"
                            placeholder="Select Role" [filter]="true" display="chip"  class="w-full" [disabled]="RoleDisabledOpt"
                            (onChange)="onRoleChange($event)" class="w-full" />
                            <!-- <p-message *ngIf="reportSecurityForm.get('viewRoleIds')?.invalid && reportSecurityForm.get('viewRoleIds')?.touched && reportSecurityForm.get('viewRoleIds')?.value.length === 0" severity="error" size="small" variant="simple">Please select at least one role.</p-message> -->
                            <small class="p-error " *ngIf="reportSecurityForm.get('viewRoleIds')?.invalid && reportSecurityForm.get('viewRoleIds')?.touched && reportSecurityForm.get('viewRoleIds')?.value.length === 0">
                                Please select at least one role.
                            </small>
                    </div>
                    <div class="field col-6">
                        <label>Teams</label>
                        <p-multiselect [options]="teamList" optionLabel="name" optionValue="code"
                            formControlName="viewTeamIds" placeholder="Select Team" [filter]="true" display="chip" class="w-full"
                            [disabled]="RoleDisabledOpt" (onChange)="onTeamChange($event)"  class=" w-full" />
                    </div>
                </div>
                <div class="flex align-items-center">
                    <div class="field pr-3">
                        <label>Allow access to all users</label>
                    </div>
                    <div class="field">
                        <p-toggleswitch formControlName="viewToAll" (onChange)="changeViewAllAccess($event)" [(ngModel)]="viewAllAccess" />
                    </div>
                </div>
            </div>
            <div class="sectWB">
                <div class="sectLab2 mb-3">Edit access configuration</div>
                <div class="grid">
                    <div class="field col-6">
                        <label>Role</label>
                        <p-multiselect [options]="editRoleList" optionLabel="name"  optionValue="code" formControlName="editRoleIds"
                        placeholder="Select Role" [filter]="true" class="w-full" [disabled]="editRoleDisabled"
                        class="w-full" />
                    </div>
                    <div class="field col-6">
                        <label>Teams</label>
                        <p-multiselect [options]="editTeamList" optionLabel="name" optionValue="code" formControlName="editTeamIds" placeholder="Select Team" class="w-full" [filter]="true" [disabled]="editRoleDisabled" class="w-full" />
                    </div>
                </div>
                <div class="flex align-items-center">
                    <div class="field pr-3">
                        <label>Allow access to all users</label>
                    </div>
                    
                    <div class="field ">
                        <p-toggleswitch formControlName="editToAll" (onChange)="changeeditAllAccess($event)" />
                        <!-- [disabled]="editAllAccess" [(ngModel)]="checked" -->
                    </div>
                </div>
                <!-- <div class="flex align-items-center">
                    <div class="field pr-3">
                        <label>Enable access based on hierarchy and reporting?</label>
                    </div>
                    <div class="field">
                        <p-toggleswitch (onChange)="changeHierarchyAccess($event)"  formControlName="enableHierarchySecurity" [(ngModel)] ="enableHierarchyAccess" />
                    </div>
                </div> -->
            </div>
        </div>
    </form>
    <ng-template #footer>
        <div class="flex items-center gap-2">
            <button pButton label="Save" (click)="saveReportSecurity() "></button>
            <button pButton label="Cancel" [outlined]="true" (click)="onCancel()" severity="secondary"></button>
        </div>
    </ng-template>

</p-drawer>